import React, { useState } from 'react';

import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import { Box, IconButton, TextField } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const PasswordInput = ({ control, label, name }) => {
    const [typeFieldPassword, setTypeFieldPassword] = useState('password');
    const showPassword = typeFieldPassword === 'text';

    const handleClickShowPassword = () => {
        if (showPassword) setTypeFieldPassword('password');
        else setTypeFieldPassword('text');
    };

    return (
        <Controller
            control={control}
            name={name}
            render={({ field, fieldState: { error } }) => (
                <TextField
                    error={Boolean(error)}
                    fullWidth
                    helperText={error ? error.message : ''}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                {!isEmpty(field.value) && (
                                    <IconButton
                                        onClick={handleClickShowPassword}
                                    >
                                        {showPassword ? (
                                            <VisibilityOffIcon fontSize="small" />
                                        ) : (
                                            <VisibilityIcon fontSize="small" />
                                        )}
                                    </IconButton>
                                )}
                            </InputAdornment>
                        ),
                    }}
                    label={
                        <Box display="flex" alignItems="center" gap={1}>
                            <LockIcon fontSize="small" /> {label}
                        </Box>
                    }
                    name={name}
                    type={typeFieldPassword}
                    {...field}
                />
            )}
        />
    );
};

PasswordInput.propTypes = {
    control: PropTypes.object,
    formValues: PropTypes.object,
    handleClickShowPassoword: PropTypes.func,
    label: PropTypes.string,
    name: PropTypes.string,
    showPassword: PropTypes.bool,
    type: PropTypes.string,
};

export default PasswordInput;
